export default "__VITE_ASSET__BiyeZ2p9__"